
<style scoped lang="scss">
  .wrapper {
    position: fixed;
    transition: all 0.2s;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
  }
  .overlay {
    width: 100%;
    height: 100%;
  }
  .content {
    position: absolute;
    background: transparent;
    // WebkitOverflowScrolling: touch;
  }
  .closeButton {
    cursor: pointer;
    position: absolute;
    opacity: 0.5;
    top: 1rem;
    right: 1rem;
    color: white;
    i {
      font-size: 3rem;
    }
  }
  .hide {
    // display: none; // widthが無くなるので不都合
    visibility: hidden;
  }
</style>

<template>
  <div :class="wrapperClassObject" :style="wrapperStyleObject">
    <div class="overlay" :style="overlayStyleObject"></div>
    <div ref="content" class="content" :style="contentStyleObject"></div>
    <div class="closeButton" @click="onClickCloseButton">
      <i class="material-icons">close</i>
    </div>
  </div>
</template>

<script>
import Plugin from './index'

export default {
  name: 'simulatorModal',
  props: {
    padding: {type: Number, default: 0},
    zIndex: {type: Number, default: 10},
    overlayAlpha: {type: Number, default: 0.9},
  },
  data () {
    return {
      isRunningSim: false,
    }
  },
  computed: {
    wrapperStyleObject() {
      return {
        "z-index": this.zIndex,
      }
    },
    wrapperClassObject() {
      return {
        'wrapper': true,
        // v-ifはコンポーネント自体消えてしまうので使えない
        'hide': !this.isRunningSim,
      }
    },
    overlayStyleObject() {
      return {
        'backgroundColor': `rgba(0, 0, 0, ${this.overlayAlpha})`,
      }
    },
    contentStyleObject() {
      return {
        'top': this.padding+"px",
        'left': this.padding+"px",
        'bottom': this.padding+"px",
        'right': this.padding+"px",
      }
    },
  },

  methods: {
    onClickCloseButton (e) {
      e.preventDefault();
      e.stopPropagation();
      Plugin.event.$emit('close');
    },

    onRunSim (music, project, params = {}) {
      if (this.isRunningSim) return;

      params.parent = this.$refs.content;
      params.musicSrc = music;
      params.musicScore = project,
      params.appMode = 'game';

      pxb.GameManager.bootApp(params);
      this.isRunningSim = true;
    },

    onCloseSim () {
      pxb.GameManager.idleApp();
      this.isRunningSim = false;
    },
  },

  beforeMount () {
    Plugin.event.$on('run', this.onRunSim.bind(this));
    Plugin.event.$on('close', this.onCloseSim.bind(this));
  },
}
</script>




// WEBPACK FOOTER //
// src/plugins/SimulatorModal/Component.vue